import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fieldForceUserVersionList } from "../../redux/actions/fieldForceAction";
import FieldForceVersionTableData from "./FieldForceVersionTableData";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import LoadingSpinnerTable from "../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const FieldForceVersionTable = ({ search, page_no, filterData }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const navigate = useNavigate();
  const [page, setPage] = useState(page_no ?? 1);
  const [fieldForceUserVersionData, setFieldForceUserVersionData] = useState(
    []
  );
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      fieldForceUserVersionList(
        {
          search,
          page,
          status:
            filterData?.status === "active"
              ? true
              : filterData?.status === "inactive"
              ? false
              : null,
        },
        onSuccess,
        onError
      )
    );
  }, [page, filterData?.status, search, dispatch]);

  const onSuccess = (data) => {
    setLoading(false);
    setFieldForceUserVersionData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterData.status) queryParams.push(`status=${filterData.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap ">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads" width={"10%"}>
                  User ID
                </th>
                <th className="table-heads" width={"10%"}>
                  Company Employee ID
                </th>
                <th className="table-heads" width={"12%"}>
                  Employee Name
                </th>
                <th className="table-heads text-nowrap" width={"12%"}>
                  Designation
                </th>
                <th className="table-heads" width={"10%"}>
                  Location
                </th>
                <th className="table-heads" width={"8%"}>
                  Division
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span
                      className={
                        filterData?.status ? "Medium_Purple fw_700" : ""
                      }
                    >
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className="position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={"active"}
                            checked={filterData.status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/user/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              filterData?.status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="status"
                            value={"inactive"}
                            checked={filterData.status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/field-force/user/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              filterData?.status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/field-force/user/version-history?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads" width={"8%"}>
                  Updated By
                </th>
                <th className="table-heads" width={"8%"}>
                  Updated Date
                </th>
                <th className="table-heads-action" width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : fieldForceUserVersionData?.users?.length > 0 ? (
                <>
                  {fieldForceUserVersionData?.users?.map((eachRow, index) => (
                    <FieldForceVersionTableData
                      data={eachRow}
                      index={index}
                      currentPage={
                        fieldForceUserVersionData?.pagination?.currentPage
                      }
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {fieldForceUserVersionData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={fieldForceUserVersionData?.pagination?.currentPage}
              totalPages={fieldForceUserVersionData?.pagination?.totalPages}
              path={"/field-force/user/version-history"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FieldForceVersionTable;

export const customStyles2 = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#000",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
